// extracted by mini-css-extract-plugin
export default {"wrapper":"CallToActionItem-module__wrapper--VzZaW","feedbackLink":"CallToActionItem-module__feedbackLink--ksP9I"};